type ArticleNode = Queries.ArticleDiscoveryQueryQuery['allKontentItemArticlePage']['nodes'][0];

/**
 * Converts an article page item to a Card component format.
 * Used by ArticleDiscovery and ToggleResources components.
 */
const getCardFromArticle = ({
  value,
  system,
}: ArticleNode): Queries.CARDFragment & {
  index_card_clickable: { value: string };
} => {
  const {
    index_headline,
    index_image,
    index_icon,
    category,
    index_perex,
    index_subheadline,
    index_cta,
    index_card_clickable,
  } = value;

  const { id, codename } = system;
  const image = index_image?.value && {
    ...index_image.value,
    description: index_image.value.description || '',
    width: index_image.value.width!,
    height: index_image.value.height!,
  };

  const hasModifiedCTA = index_cta?.value && index_cta.value !== '';

  return {
    __typename: 'kontent_item_card',
    index_card_clickable: {
      value: index_card_clickable?.value === 'no' ? index_card_clickable?.value : 'yes',
    },
    elements: {
      headline: {
        value: index_headline.value,
      },
      image: {
        value: image
          ? {
              url: image.url,
              description: image.description || null,
            }
          : null,
      },
      link: {
        value: {
          __typename: 'kontent_item_link',
          system: {
            codename: `link-${id}`,
            id: `link-${id}`,
          },
          linkElements: {
            cmsVariant: null,
            action: {
              value: {
                __typename: 'kontent_item_link_action_internal_page',
                elements: {
                  page: {
                    value: {
                      system: {
                        codename,
                      },
                    },
                  },
                  building_block_wrapper: null,
                },
              },
            },
            target: {
              value: '_self',
            },
            icon: {
              value: null,
            },
            text: {
              value: hasModifiedCTA
                ? index_cta.value
                : `Read ${category.value.elements.name.value}`,
            },
            event: {
              value: null,
            },
          },
        },
      },
      body: {
        value: index_perex.value,
      },
      body_rich_text: {
        value: '<p><br></p>',
      },
      background_color: {
        value: null,
      },
      eyebrow: {
        value: index_subheadline.value,
      },
      icon: {
        value: index_icon?.value
          ? {
              url: index_icon.value.url,
              description: index_icon.value.description,
              width: 32,
              height: 32,
              type: 'image',
              name: 'icon',
            }
          : null,
      },
      info_tag: {
        value: null,
      },
    },
    system: {
      codename: `card-${id}`,
      id,
    },
  };
};

export default getCardFromArticle;
